import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { PostPermissions } from "../../api/api";

type PermissionsResult = {
  status: string;
  notification?: boolean;
  msg?: string;
};

type PermissionsAttachDetachConfig = {
  resourceType: string;
  resourceName: string;
  permissionOp: string;
  targetUsers: string[];
};

export const useAttachDetachPermissions = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: ({
      resourceType,
      resourceName,
      permissionOp,
      targetUsers,
      token,
    }: PermissionsAttachDetachConfig & {
      token: string;
    }): Promise<PermissionsResult> =>
      PostPermissions(token, {
        resourceType,
        resourceName,
        permissionOp,
        targetUsers,
      }),

    onSuccess: (data) => {},

    onError: (error) => {
      console.error(
        "Error performing miner operations:",
        error
      );
    },
  });

  const mutateWithToken = useCallback(
    async (
      {
        resourceType,
        resourceName,
        permissionOp,
        targetUsers,
      }: PermissionsAttachDetachConfig,
      options?: {
        onSuccess?: (data: PermissionsResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      console.log(
        "sites in attach permissions",
        targetUsers
      );
      const token = await getAccessTokenSilently();
      console.log();
      mutation.mutateAsync(
        {
          resourceType,
          resourceName,
          permissionOp,
          targetUsers,
          token,
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
